import { createApiInstance } from "./apiInstance";
import { apiCall } from "./apiCall";
import { Method } from "axios";

const qplusApi = createApiInstance(process.env.REACT_APP_QPLUS_BASE_URL || "https://payment-qplus.onepay.lk/");

export const qplusApiCall = (
  url: string,
  method: Method = 'GET',
  data: any = null,
  header: string | null = null,
  encrypt: boolean = false
): Promise<any> => {
  return apiCall(qplusApi, url, method, data, header, encrypt,false);
};
